import * as React from 'react';
import { Image, UIHeading4, IconArrowRight16 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { IStandardOffer } from '../../../../settings';

interface IOfferCardProps {
  offer: IStandardOffer;
  onClick(offer: IStandardOffer): void;
}

export function OfferCard({ offer, onClick }: IOfferCardProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['image']}>
        <Image objectFit="cover" width="100%" height="100%" preloader src={offer.thumbnailUrl} />
      </div>

      <div className={styles['content']}>
        <div className={styles['title']}>
          <UIHeading4 color={'white_100'}>{offer.title}</UIHeading4>
        </div>
        <div className={styles['button']} onClick={() => onClick(offer)} data-testid="offer_card_button">
          <div className={styles['button-text']}>Подробнее</div>
          <div className={styles['button-icon']}>
            <IconArrowRight16 color="white_100" />
          </div>
        </div>
      </div>
    </div>
  );
}
